import { useAccount } from '@bnnvara/accounts';
import PropTypes from 'prop-types';
import React from 'react';

import { PersonalizedRecommendationQuery } from '../../../api/queries/recommendation.gql';
import PageQuery from '../../PageQuery';
import RecommendationBlock from '../RecommendationBlock';
import RelatedRecommendation from '../RelatedRecommendation/RelatedRecommendation';

const PersonalizedRecommendation = ({ id, type }) => {
  const {
    profile: { UID },
  } = useAccount();

  if (!UID) {
    return <RelatedRecommendation id={id} type={type} />;
  }

  return (
    <PageQuery
      query={PersonalizedRecommendationQuery}
      variables={{
        userId: UID,
        contentId: id,
        limit: 4,
        contentType: type,
      }}
    >
      {({ data }) => {
        const { edges } = data.personalizedRecommendation;
        return (
          edges?.length > 0 && (
            <RecommendationBlock
              results={edges}
              title="Geselecteerd voor jou"
              recomType="gepersonaliseerd"
            />
          )
        );
      }}
    </PageQuery>
  );
};

PersonalizedRecommendation.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default PersonalizedRecommendation;
